var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy-right-container"},[_vm._m(0),_c('div',{staticClass:"copy-right-link",on:{"click":_vm.handleOpenportalWebsite}},[_c('img',{attrs:{"src":"","alt":""}}),_c('span',[_vm._v("quanqiuwa.com")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy-right-image"},[_c('img',{attrs:{"src":require("@/image/logo/copy-right@3x.png")}})])
}]

export { render, staticRenderFns }